'use client'

import Link from 'next/link'

import { Chip } from '@heroui/react'
import { Tooltip } from '@components/main/PlatformTooltips'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import Header from './Header'
import { isPublicPlatformPath } from '@utils/publicPlatformRoutes'
import { Menu, X } from 'lucide-react'

// ▼ новый код: утилита названия плана
const tariffs = [
    { value: 'demo', title: 'DEMO', short: 'D' },
    { value: 'base', title: 'BASE', short: 'B' },
    { value: 'pro', title: 'PRO', short: 'P' },
    { value: 'proplus', title: 'PRO+', short: 'P+' },
    { value: 'enter', title: 'GENIUS', short: 'G' },
    { value: 'individual', title: 'I++', short: 'I' },
    { value: 'test', title: 'TEST', short: 'R' },
]

export default function Nav({
    isValid,
    signoutHandler,
    t,
    timeLeft,
    fastTokens = 0,
    fastCap = 0,
    userTokens = 0,
}: {
    isValid: any
    signoutHandler: any
    t?: any
    timeLeft: any
    fastTokens?: number
    fastCap?: number
    userTokens?: number
}) {
    const pathname = usePathname()
    const accessPages = ['/signin', '/signup', '/', '/development', '/404', '/signin', '/superadmin', '/yukassaagentslink']

    const ismenu = accessPages.includes(pathname) || isPublicPlatformPath(pathname)

    const hasPlanTokens = t === 'proplus'

    const [time, setTime] = useState(skolko(timeLeft))

    function skolko(date: any) {
        let currentDate = new Date() as any
        let oDays = Math.floor(Number(date - currentDate) / 1000 / 60 / 60 / 24)

        return oDays
    }

    useEffect(() => {
        if (!isValid) {
            setTime(skolko(timeLeft))
        }
    }, [])

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

    let links = [
        {
            href: '#',
            title: 'Личный кабинет',
            parent: true,
            type: 'profile',
        },
        {
            icon: '/assets/icons/nav/profile.svg#icon',
            href: '/panel/profile',
            title: 'Мой профиль',
            type: 'profile',
            helptext: '',
        },
        {
            icon: '/assets/icons/nav/subscribe.svg#icon',
            href: '/panel/subscribe',
            title: 'Моя подписка',
            type: 'profile',
        },
        {
            icon: '/assets/icons/nav/brandbook.svg#icon',
            href: '/panel/ai',
            title: 'Мой БрендБук',
            type: 'profile',
        },
        {
            icon: '/assets/icons/nav/rules.svg#icon',
            href: '/panel/rules',
            title: 'Мои права',
            type: 'profile',
            disabled: true,
        },

        {
            href: '#',
            title: 'Мои мессенджеры',
            parent: true,
            type: 'Messengers',
        },
        {
            icon: '/assets/icons/nav/botincludes.svg#icon',
            href: '/panel/botcreate',
            title: 'Подключение бота',
            type: 'Messengers',
            disabled: true,
        },
        {
            icon: '/assets/icons/nav/botconfig.svg#icon',
            href: '/panel/botconfig',
            title: 'Настройки бота',
            type: 'Messengers',
        },
        {
            icon: '/assets/icons/nav/offer.svg#icon',
            href: '/panel/pages/policy',
            title: 'Моя Политика',
            type: 'Messengers',
            disabled: true,
        },
    ] as any
    if (t != 'individual')
        links = links.concat([
            {
                href: '#',
                title: 'Моя библиотека',
                parent: true,
                type: 'case',
            },
            {
                /*
          icon: "/assets/icons/nav/logo.svg#icon",
          href: "#",
          title: "Скелетные",
          type: 'case',
          disabled: true
      */
            },
            {
                icon: '/assets/icons/nav/logo.svg#icon',
                href: '#',
                title: 'Компоненты',
                type: 'case',
            },
            {
                href: '#',
                title: 'Конструктор',
                parent: true,
                type: 'pages',
            },
            {
                icon: '/assets/icons/nav/loading.svg#icon',
                href: '/panel/pwasetting',
                title: 'Настройка приложения',
                type: 'pages',
            },
            {
                icon: '/assets/icons/nav/mypages.svg#icon',
                href: '/panel/applicationv2',
                title: 'Мои страницы',
                type: 'pages',
            },
            {
                icon: '/assets/icons/nav/histories.svg#icon',
                href: '/panel/onboardings',
                title: 'Мои онбординги',
                type: 'pages',
            },
            {
                icon: '/assets/icons/nav/slider.svg#icon',
                href: '#',
                title: 'Моё хранилище',
                type: 'pages',
            },
            {
                icon: '/assets/icons/nav/histories.svg#icon',
                href: '/panel/histories',
                title: 'Мои Сторис',
                type: 'pages',
            },
            {
                icon: '/assets/icons/nav/histories.svg#icon',
                href: '/panel/events',
                title: 'Мои события',
                type: 'pages',
            },
            {
                icon: '/assets/icons/nav/systempages.svg#icon',
                href: '/panel/pagesservice',
                title: 'Системные страницы',
                type: 'pages',
            },
        ])
    if (t != 'individual')
        links = links.concat([
            {
                href: '#',
                title: 'Мой маркетинг',
                parent: true,
                type: 'marketing',
            },
            {
                icon: '/assets/icons/nav/referal.svg#icon',
                href: '/panel/referal',
                title: 'Реферальная программа',
                type: 'marketing',
            },
            {
                icon: '/assets/icons/nav/refstatuses.svg#icon',
                href: '/panel/referal/statuses',
                title: 'Накопительная программа',
                type: 'marketing',
            },
        ])
    links.push({
        icon: '/assets/icons/nav/stocks.svg#icon',
        href: '/panel/stocks',
        title: 'QR-конструктор',
        type: 'marketing',
    })
    if (t != 'individual')
        links = links.concat([
            {
                icon: '/assets/icons/nav/calendar.svg#icon',
                href: '/panel/questions',
                title: 'Мои сценарии',
                type: 'marketing',
            },
            {
                href: '#',
                title: 'Мой каталог',
                parent: true,
                type: 'catalog',
            },
            {
                icon: '/assets/icons/nav/categories.svg#icon',
                href: '/panel/catalog/categories',
                title: 'Категории товаров',
                type: 'catalog',
            },
            {
                icon: '/assets/icons/nav/catalog.svg#icon',
                href: '/panel/catalog',
                title: 'Товары',
                type: 'catalog',
            },
        ])

    links = links.concat([
        {
            href: '#',
            title: 'VC CRM',
            parent: true,
            type: 'VC CRM',
        },
        {
            title: 'Мои Заявки',
            icon: '/assets/icons/nav/crmrequests.svg#icon',
            href: '/panel/crm/crmrequests',
            type: 'VC CRM',
        },
        {
            title: 'Мои Сделки',
            icon: '/assets/icons/nav/crmdeals.svg#icon',
            href: '/panel/crm/crmdeals',
            type: 'VC CRM',
        },

        {
            title: 'Мои Клиенты',
            icon: '/assets/icons/nav/crmclients.svg#icon',
            href: '/panel/crm/crmclients',
            type: 'VC CRM',
        },
        {
            title: 'Карта воронок',
            icon: '/assets/icons/nav/crmmap.svg#icon',
            href: '/panel/crm/crmmap',
            type: 'VC CRM',
        },
        {
            href: '/panel/dashboards',
            title: 'Моя Аналитика',
            icon: '/assets/icons/nav/dashboards.svg#icon',
            type: 'VC CRM',
        },
    ])

    links = links.concat([
        {
            href: '#',
            title: 'Чат-бот',
            parent: true,
            type: 'textbot',
            chat: true,
        },
        {
            icon: '/assets/icons/nav/chat.svg#icon',
            href: '#',
            title: 'Открыть чат',
            type: 'textbot',
            chat: true,
        },
        {
            icon: '/assets/icons/nav/textbt.svg#icon',
            href: '/panel/textbt',
            title: 'Редактор приветствия',
            type: 'textbot',
        },
        {
            icon: '/assets/icons/nav/notification.svg#icon',
            href: '/panel/textbttime',
            title: 'Отложенные рассылки',
            type: 'textbot',
        },
    ])
    /* user.tarif != 'individual' &&
      links.push(
      {
          icon: "/assets/icons/nav/textbtcrm.svg#icon",
          href: "/panel/textbtcrm",
          title: "Рассылки из CRM",
          type: 'textbot'
      })
      /*{
          icon: "/assets/icons/nav/textbtauto.svg#icon",
          href: "/panel/textbtauto",
          title: "Автоответчик",
          type: 'textbot'
      },*/
    links = links.concat([
        {
            href: '#',
            title: 'Мои Интеграции',
            parent: true,
            type: 'integration',
        },
        {
            icon: '/assets/icons/nav/crm.svg#icon',
            href: '/panel/synchronization',
            title: 'CRM-системы',
            type: 'integration',
        },
        {
            icon: '/assets/icons/nav/payments.svg#icon',
            href: '/panel/payments',
            title: 'Платежные системы',
            type: 'integration',
            disabled: true,
        },
        {
            icon: '/assets/icons/nav/onlinecourses.svg#icon',
            href: '/panel/onlinecourses',
            title: 'Онлайн-курсы',
            type: 'integration',
            disabled: true,
        } /*,
    {
        icon: "/assets/icons/nav/kassa.svg#icon",
        href: "#",
        title: "Касса",
        type: 'integration',
        disabled: true
    }*/,
        {
            href: '#',
            title: 'Модули',
            parent: true,
            type: 'modules',
        },
        {
            icon: '/assets/images/loogoold.png',
            href: '/panel/modules',
            title: 'Модули от Vcentre IT',
            type: 'modules',
            disabled: true,
        },
        {
            icon: '/assets/images/loogo.png',
            href: '/panel/aiassistant',
            title: 'ИИ-ассистент',
            type: 'modules',
            disabled: true,
        },
    ])

    type LinkItem = {
        href?: string
        title: string
        parent?: boolean
        type?: string
        icon?: string
        disabled?: boolean
        chat?: boolean
    }

    const renderMenu = (links: LinkItem[]) => {
        const out: React.ReactNode[] = []
        let currentSection: { title: string; items: LinkItem[] } | null = null

        const flush = () => {
            if (!currentSection) return
            out.push(
                <div key={`section-${out.length}`} className="space-y-2">
                    <div className="text-xs uppercase tracking-wide text-muted-foreground px-2">{currentSection.title}</div>

                    <div className="flex flex-col gap-1">
                        {currentSection.items.map((link, idx) => (
                            <Link key={`${link.href ?? link.title}-${idx}`} href={link.href || '#'} className={`button-no-border`}>
                                {link.title}
                            </Link>
                        ))}
                    </div>
                </div>,
            )
            currentSection = null
        }

        for (const link of links) {
            if (link.parent) {
                // новая секция — сначала закрываем предыдущую
                flush()
                currentSection = { title: link.title, items: [] }
            } else {
                // если вдруг пункт встретился до первого parent — создадим секцию без заголовка
                if (!currentSection) currentSection = { title: '', items: [] }
                currentSection.items.push(link)
            }
        }

        flush()
        return out
    }

    return (
        <>
            {ismenu ? (
                <Header isValid={isValid} />
            ) : (
                <header
                    className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-transparent py-2 max-w-[2048px] mx-auto`}
                >
                    <div className="section-container flex items-center justify-between max-w-[2048px]">
                        {/* Logo */}
                        <a href="/" className="flex items-center">
                            <img src={'/assets/images/vcentreone.png'} alt="Vcentre" className="h-8 w-auto" />
                        </a>

                        <div className="hidden md:flex flex-row-reverse gap-4">
                            {!isValid ? (
                                <>
                                    <Link type="button" href="/signin" className="button-no-border">
                                        Регистрация
                                    </Link>
                                    <Link type="button" href="/signin" className="button-border">
                                        Вход
                                    </Link>
                                </>
                            ) : (
                                <>
                                    <Link
                                        type="button"
                                        href="/"
                                        className="button-border"
                                        onClick={() => {
                                            void signoutHandler()
                                        }}
                                    >
                                        выход
                                    </Link>
                                    <Link type="button" href="/panel" className="button-no-border">
                                        Панель управления
                                    </Link>
                                    {/* ▼ новый код: Бейдж токенов с поповером */}
                                    <div className="relative group">
                                        <Link href="#" className="token-badge">
                                            <div className="flex items-center gap-2 leading-none">
                                                <div className="flex items-center gap-2">
                                                    {/* светящаяся буква/метка тарифа */}
                                                    <span className="tarif-pill">
                                                        <span className="tarif-letter">
                                                            {tariffs.find((tarif: any) => tarif.value === t)?.title || '—'}
                                                        </span>
                                                    </span>

                                                    {/* мелко — остаток дней */}
                                                    <span className="tarif-days">{typeof time === 'number' ? `${time} дн.` : ''}</span>
                                                    {hasPlanTokens && (
                                                        <div className="token-row">
                                                            <span className="token-dot" />
                                                            <span className="token-title">
                                                                токены {fastCap ? `${fastTokens}/${fastCap}` : fastTokens}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </Link>

                                        {/* Popover */}
                                        <div className="plan-popover group-hover:opacity-100 group-hover:translate-y-0 pointer-events-none group-hover:pointer-events-auto">
                                            <div className="plan-popover-row">
                                                <span className="plan-popover-title">Мой тариф</span>
                                                <span className="plan-chip">
                                                    {tariffs.find((tarif: any) => {
                                                        return tarif.value == t
                                                    })?.title || ''}
                                                </span>
                                            </div>

                                            <div className={`plan-popover-row ${hasPlanTokens ? '' : 'row-disabled'}`}>
                                                <div className="flex items-center gap-1">
                                                    <span className="plan-popover-title">Токены к тарифу</span>
                                                    <Tooltip content="Быстрые токены тарифа доступны только на плане PRO+">
                                                        <Chip size="sm" color="default">
                                                            ?
                                                        </Chip>
                                                    </Tooltip>
                                                </div>
                                                <span className="plan-value">
                                                    {hasPlanTokens ? (fastCap ? `${fastTokens} / ${fastCap}` : fastTokens) : 'Недоступно'}
                                                </span>
                                            </div>

                                            <div className={`plan-popover-row ${hasPlanTokens ? '' : 'row-disabled'}`}>
                                                <div className="flex items-center gap-1">
                                                    <span className="plan-popover-title">Ваши токены</span>
                                                    <Tooltip content="Эти токены вы докупаете дополнительно и расходуете сверх лимита тарифа">
                                                        <Chip size="sm" color="default">
                                                            ?
                                                        </Chip>
                                                    </Tooltip>
                                                </div>
                                                <span className="plan-value">{userTokens}</span>
                                            </div>

                                            <Link href="/panel/subscribe" className="button-upgrade">
                                                Улучшить
                                            </Link>
                                        </div>
                                    </div>
                                    {/* ▲ конец нового блока */}
                                </>
                            )}
                        </div>

                        {/* Mobile Menu Toggle */}
                        <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2 text-foreground">
                            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                        </button>
                    </div>

                    {/* Mobile Menu */}
                    {isMobileMenuOpen && (
                        <div className="lg:hidden glass-strong mt-2 mx-4 rounded-lg p-4 animate-fade-in h-[80vh] overflow-y-auto">
                            <nav className="flex flex-col gap-3">
                                {isValid && (
                                    <div className="plan-popover-mobile group-hover:opacity-100 group-hover:translate-y-0 pointer-events-none group-hover:pointer-events-auto">
                                        <div className="plan-popover-row">
                                            <span className="plan-popover-title">Мой тариф</span>
                                            <span className="plan-chip">
                                                {tariffs.find((tarif: any) => {
                                                    return tarif.value == t
                                                })?.title || ''}
                                            </span>
                                        </div>

                                        <div className={`plan-popover-row ${hasPlanTokens ? '' : 'row-disabled'}`}>
                                            <div className="flex items-center gap-1">
                                                <span className="plan-popover-title">Токены к тарифу</span>
                                                <Tooltip content="Быстрые токены тарифа доступны только на плане PRO+">
                                                    <Chip size="sm" color="default">
                                                        ?
                                                    </Chip>
                                                </Tooltip>
                                            </div>
                                            <span className="plan-value">
                                                {hasPlanTokens ? (fastCap ? `${fastTokens} / ${fastCap}` : fastTokens) : 'Недоступно'}
                                            </span>
                                        </div>

                                        <div className={`plan-popover-row ${hasPlanTokens ? '' : 'row-disabled'}`}>
                                            <div className="flex items-center gap-1">
                                                <span className="plan-popover-title">Ваши токены</span>
                                                <Tooltip content="Эти токены вы докупаете дополнительно и расходуете сверх лимита тарифа">
                                                    <Chip size="sm" color="default">
                                                        ?
                                                    </Chip>
                                                </Tooltip>
                                            </div>
                                            <span className="plan-value">{userTokens}</span>
                                        </div>

                                        <Link href="/panel/subscribe" className="button-upgrade">
                                            Улучшить
                                        </Link>
                                    </div>
                                )}
                                {!isValid ? (
                                    <>
                                        <Link type="button" href="/signin" className="button-border">
                                            Вход
                                        </Link>
                                        <Link type="button" href="/signin" className="button-no-border">
                                            Регистрация
                                        </Link>
                                    </>
                                ) : (
                                    <>
                                        <Link type="button" href="/panel" className="button-no-border">
                                            Главная
                                        </Link>
                                        <div className="space-y-6">{renderMenu(links)}</div>
                                        <Link
                                            type="button"
                                            href="/"
                                            className="button-border"
                                            onClick={() => {
                                                void signoutHandler()
                                            }}
                                        >
                                            выход
                                        </Link>
                                    </>
                                )}
                                {/*navItems.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                onClick={() => setIsMobileMenuOpen(false)}
                                className="text-sm text-muted-foreground hover:text-primary transition-colors py-2"
                            >
                                {item.label}
                            </a>
                        ))
                        <Button className="mt-2 w-full btn-glow !bg-success !text-main">
                            <Link href={isValid ? '/panel' : '/signin'}>Войти</Link>
                        </Button>*/}
                            </nav>
                        </div>
                    )}
                </header>
            )}
        </>
    )
}
